// Course Promo Component
// Displays the process optimization course promotion section

class CoursePromo extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private render() {
    this.innerHTML = `
      <div class="max-w-4xl mx-auto mt-16 p-8 bg-white rounded-2xl shadow-lg border-2 border-amber-200">
        <div class="text-center">
          <h3 class="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
            <span data-en="Process Optimization Course" data-lv="Procesu Optimizācijas Kurss"
              data-it="Corso di Ottimizzazione dei Processi">Process Optimization Course</span>
          </h3>
          <p class="text-lg text-amber-600 font-semibold mb-4">
            <span data-en="Coming soon..." data-lv="Drīzumā..." data-it="Prossimamente...">Coming soon...</span>
          </p>
          <p class="text-slate-600">
            <span data-en="The first lesson is already included in all our offers."
              data-lv="Pirmā nodarbība jau ir iekļauta visos mūsu piedāvājumos."
              data-it="La prima lezione è già inclusa in tutte le nostre offerte.">
              The first lesson is already included in all our offers.
            </span>
          </p>
        </div>
      </div>
    `;
  }
}

customElements.define("course-promo", CoursePromo);

export { CoursePromo };

